export default "__VITE_ASSET__e4ad8d8c__"